import { MotionValue, useTransform } from 'framer-motion'
import { forwardRef, useEffect, useRef } from 'react'

import { Container, UI } from './styled'

type Props = {
  progress: MotionValue<number>
  onScroll: (delta: number) => void
  isSticky?: boolean
}

export const Knob = forwardRef<HTMLSpanElement, Props>(
  ({ onScroll, progress, isSticky }, scrollRef) => {
    const ref = useRef<HTMLDivElement>(null)
    const rotateZ = useTransform(progress, v => `${v / 2}deg`)

    const handelWheel = (evt: WheelEvent) => {
      evt.preventDefault()
      evt.stopPropagation()
      onScroll(evt.deltaY / 10)
    }

    useEffect(() => {
      const r = ref.current
      r?.addEventListener('wheel', handelWheel, { passive: false })
      return () => r?.removeEventListener('wheel', handelWheel)
    }, [])

    return (
      <Container isSticky={isSticky} ref={scrollRef}>
        <UI
          style={{ rotateZ }}
          onPan={(_evt, info) => onScroll(info.delta.x)}
          ref={ref}
        />
      </Container>
    )
  }
)
